import React from 'react';

import {
  Button,
  Container,
  Heading,
  Link,
  Stack,
  Text,
} from '@joinrepublic/dls-ui-kit';
import { useRouter } from 'next/router';

export interface IErrorMessageProps {
  title?: string;
  subTitle?: string;
  hideReload?: boolean;
  compact?: boolean;
  userMessage?: string;
  children?: React.ReactNode;
}

export const ErrorMessage = ({
  title = 'Oops! We made a mistake.',
  userMessage = "Apologies for the inconvenience. We've been notified of this error and are working to fix it.",
  subTitle,
  hideReload = false,
  compact,
  children,
}: IErrorMessageProps) => {
  const router = useRouter();

  return (
    <Container
      maxW={compact ? 'container.sm' : 'container.lg'}
      my="16"
      textAlign="center"
    >
      <Heading v="2.2" size="title-600" color="grey.900">
        {title}
      </Heading>
      {!!subTitle && (
        <Text v="2.2" size="body-500" color="grey.500" mb="4">
          {subTitle}
        </Text>
      )}
      <Text v="2.2" size="body-600" color="grey.600">
        {userMessage}
      </Text>
      {!hideReload && (
        <Text v="2.2" size="body-600" color="grey.600">
          Please, try to{' '}
          <Link as="button" type="button" onClick={() => router.reload()}>
            reload
          </Link>{' '}
          page and repeat the action.
        </Text>
      )}
      {!children && (
        <Text v="2.2" size="body-500" color="grey.600" mt="8">
          If this does not help, in the meantime, you can:
        </Text>
      )}
      <Stack
        mt="6"
        spacing="4"
        direction={{ base: 'column', md: 'row' }}
        justify="center"
      >
        {children ?? (
          <>
            <Button as="a" href="/investment-opportunities" variant="secondary">
              Explore startups
            </Button>
            <Button as="a" href="/issuer/learn" variant="secondary">
              Raise money
            </Button>
          </>
        )}
      </Stack>
    </Container>
  );
};
